import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import useSearchParams from 'modules/core/hooks/useSearchParams'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import ProcessFromTemplateWizard from 'modules/processes/pages/Modals/ProcessFromTemplateWizardPage/ProcessFromTemplateWizard'

interface QueryParams {
  templateCategory: number
}

const ProcessFromTemplateWizardPage = () => {
  const { category: id } = useParams()
  const { navigation } = useNavigation()
  const { templateCategory: category } = useSearchParams<QueryParams>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(
      navigation.processes.template.fullPath({
        category: category,
      }),
      { replace: true }
    )
  }

  const onSuccess = (processId: number) => {
    if (!category) return

    track(trackingEvents.processes.newTemplateWorkflowSaved, {
      category: category,
      id: id,
      processId,
    })

    navigate(
      navigation.processes.template.id.settings.fullPath({
        category: category,
        id: processId,
      }),
      { replace: true }
    )
  }

  if (!id) {
    onClose()
    return null
  }

  return <ProcessFromTemplateWizard templateId={id} onClose={onClose} onSuccess={onSuccess} />
}

export default ProcessFromTemplateWizardPage
